import React from 'react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import type { DatasetDef, DatasetKey } from '@/hooks/useReportBuilder';

interface Props {
  datasets: DatasetDef[];
  selected: DatasetKey;
  onChange: (key: DatasetKey) => void;
}

export const DatasetSelector: React.FC<Props> = ({ datasets, selected, onChange }) => (
  <div className="space-y-1.5">
    <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground px-1">Dataset</p>
    <div className="grid grid-cols-2 gap-1.5">
      {datasets.map(d => (
        <button
          key={d.key}
          onClick={() => onChange(d.key)}
          className={cn(
            'flex items-center gap-2 rounded-lg border px-3 py-2.5 text-left transition-colors text-sm',
            selected === d.key
              ? 'border-primary bg-primary/10 text-primary font-medium'
              : 'border-border bg-card text-foreground hover:bg-muted'
          )}
        >
          <span className="text-base leading-none">{d.icon}</span>
          <span className="flex-1 truncate">{d.label}</span>
          {d.adminOnly && (
            <Badge variant="secondary" className="text-xs px-1 py-0 leading-none shrink-0">
              Admin
            </Badge>
          )}
        </button>
      ))}
    </div>
  </div>
);
